import React from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import Filtering from "../../public/img/seller-leads-advanced.png"
import Global from "../../public/img/global-search.png"
import Business from "../../public/img/spreadsheet.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import NextLink from "next/link"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import { advancedSellerSearchFaq } from "../../data/AdvancedSellerSearchFaq"

export default function AdvancedSellerSearch() {
  const textColor = useColorModeValue("gray.500", "white")

  function ButtonClick() {
  }
  return (
    <>
      <Meta
        pageName={"Advanced Amazon Sellers Search to Find The Right Seller - TrackSellers"}
        description={"Find the right Amazon Seller with our Advanced Seller Search. With over 5 million Amazon Sellers, find sellers as per location, marketplace & more."}
        hrefLink={"https://www.tracksellers.com/advanced-seller-search"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                Discover the Power of Advanced Amazon Seller Search
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Unleash the full potential of your Amazon seller lead generation with our cutting-edge search capabilities.
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "0rem", md: "1rem", lg: "1rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems={{ base: "flex-start", md: "flex-start", lg: "center" }}
                direction={{ base: "column", sm: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Filtering}
                    alt="Filtering"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Precise Amazon Seller Search Filtering for Optimal Results
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Refine your search with a wide range of criteria, including seller rank, category, location, rank, sales, reviews, ratings, and more
                        </Text>
                      </Flex>

                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Target specific niches or segments to uncover high-quality leads
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Save time and effort by narrowing down your search to the most relevant and promising sellers
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems={{ base: "flex-start", md: "flex-start", lg: "center" }}
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Advanced Amazon Seller Search Features for Global Reach
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Search 5 million sellers across 12 different Amazon marketplaces for a truly international lead generation experience
                    </Text>

                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Find sellers from specific countries operating in particular marketplaces, targeting unique opportunities
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Leverage the full potential of TrackSellers&apos; comprehensive database and global coverage
                    </Text>

                  </Flex>

                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Global}
                    alt="Global"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems={{ base: "flex-start", md: "flex-start", lg: "center" }}
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    objectFit="contain"
                    src={Business}
                    alt="Business"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Take Your Research to the Next Level
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Easily download seller-specific data and metrics in Excel/CSV format.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Integrate the comprehensive data into your favorite CRM for seamless lead management.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Streamline your research and lead nurturing process with quick access to vital information.
                    </Text>
                  </Flex>

                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Experience The Power Of Advanced Seller Search Today
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Don&apos;t miss out on the opportunity to supercharge your Amazon seller lead generation with our Advanced Seller Search feature. Sign up for TrackSellers today and unlock the full potential of your lead generation efforts.
          </Text>
          <NextLink href={"/get-started"} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                advancedSellerSearchFaq?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}